import { useCompanyValues } from '@/providers';
import { FC, useReducer } from 'react';
import { twMerge } from 'tailwind-merge';
import { PoweredBy } from '../layout/Footers';
import { ReturnToLoginButton } from './components';
import { ResetPasswordBackground } from './components/ResetPasswordBackground/ResetPasswordBackground';
import { RESET_PASSWORD_LOGOS } from './constants';
import { ResetPasswordCompleteContent } from './ResetPasswordCompleteContent';
import { ResetPasswordFormContent } from './ResetPasswordFormContent';
import LanguageToggle from '@/components/LanguageToggle';

export const ResetPasswordPage: FC = () => {
  const [isSent, setIsSent] = useReducer((state) => !state, false);

  const { company, isExternal } = useCompanyValues();

  return (
    <main className={twMerge('box-border grid h-dvh w-screen grid-cols-2 reltive', isExternal && 'bg-yellow-500')}>
      <div className='relative flex flex-col justify-center p-8'>
        <div className='absolute right-8 top-8'>
          <LanguageToggle />
        </div>
        <div className='absolute left-8 top-8'>{RESET_PASSWORD_LOGOS[company]}</div>
        <div className='flex w-[22.5rem] flex-col items-center gap-8 self-center'>
          {isSent ? <ResetPasswordCompleteContent /> : <ResetPasswordFormContent onPasswordRecoverySent={setIsSent} />}
          <ReturnToLoginButton />
        </div>
        {isExternal && <PoweredBy className='absolute bottom-8 left-8' />}
      </div>
      <ResetPasswordBackground />
    </main>
  );
};
